// extracted by mini-css-extract-plugin
module.exports = {"dialog":"table_theme__dialog--mQ3yh","table":"table_theme__table--1JmhA","head":"table_theme__head--d3_Pi","selected":"table_theme__selected--31985"};